import styles from "./RecentTrades.module.css"
const RecentTrades = () => {
  return (
          <div className={styles.recent_trades_content}>
              <span className={styles.no_recent_trades}>You transactions will appear here.</span>
    </div>
  )
}

export default RecentTrades